export const GENDERS = {
    MALE: 'Nam',
    FEMALE: 'Nữ',
};
